import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectSPArrayModel,
  ProjectSPModel,
} from "../../models/ProjectSPModel";
import { UpdateBidSubmissionDetailsModel } from "../../models/ProjectModel";

const initialProjectSPState: ProjectSPArrayModel = {
  particular_ProjectSP: {
    projectId: 0,
    userId: 0,
    projectName: "",
    createdBy: "",
    buName: "",
    segmentLob: "",
    segmentClassification: "",
    customerGreenClassification: false,
    isBaseLoad: false,
    isGreenListCustomer: false,
    assessCustomerRating: "",
    briefScope: "",
    estimatedValue: 0,
    valueSlab: "",
    isNewProcessApplicable: undefined,
    preBidExpenses: 0,
    isPriceVariation: "",
    isPqrequired: "",
    preQualificationRequirement: "",
    isJvpartnerRequired: false,
    jvpartnerSuggestedName: "",
    isTechPartnerRequired: false,
    techPartnerSuggestedName: "",
    winProbabilityPercentage: 0,
    projectDuration: 0,
    isOM: false,
    omduration: 0,
    estimatedTimeToBid: 0,
    environmentClearanceStatus: "",
    country: "",
    state: "",
    city: "",
    location: "",
    isLicenseRequired: false,
    licenseProcurementNextSteps: "",
    rowstatus: "",
    tenderMaturity: "",
    expectedCompetitors: "",
    additionalInformation: "",
    modifiedBy: "",
    contractType: "",
    customerName: "",
    geography: "",
    competitionIntensity: "",
    proposalStage:"",
    competitorsWithClient:"",
    winStrategyAndValueProposition:"",
    countryCorruptionRating:"",
    tenderingBandwidth: "",
    fundingSource: "",
    isActive: false,
    goFactorPercentage: 0,
    getFactorPercentage: 0,
    manualGoFactorPercentage: 0,
    manualGetFactorPercentage: 0,
    manualGoGetFactorPercentage: 0,
    manualGoGetFactorRemarks: "",
    projectOverallWinLossStatus: "",
    bidManagerName: "",
    isNewTeprocessCommenced: undefined,
    isWorkStarted: undefined,
    bidSubmissionDate: new Date(),
    opportunityQualification: "",
    bidExploratoryStatus: false,
    isBidDropped: false,
    priority: "",
    enforceCsgoApproval: false
  },
};
const ProjectSPSlice = createSlice({
  name: "ProjectSP",
  initialState: initialProjectSPState,
  reducers: {
    setParticularProjectSP(state, action: PayloadAction<ProjectSPModel>) {
      state.particular_ProjectSP = action.payload;
    },
    setProjectSPWithInitialValues: (state) => {
      state.particular_ProjectSP = initialProjectSPState.particular_ProjectSP;
    },
    setProjectBidSubmissionData(
      state,
      action: PayloadAction<UpdateBidSubmissionDetailsModel>
    ) {
      const { estimatedValue, bidSubmissionDate, tenderMaturity } = action.payload;
      state.particular_ProjectSP.estimatedValue = estimatedValue;
      state.particular_ProjectSP.bidSubmissionDate = bidSubmissionDate;
      state.particular_ProjectSP.tenderMaturity= tenderMaturity;
    },
    setIsBidDropped(state, action: PayloadAction<boolean>) {
      state.particular_ProjectSP.isBidDropped = action.payload;
    },
    setBidPriority(state, action: PayloadAction<string>) {
      state.particular_ProjectSP.priority = action.payload;
    },
  },
});
export default ProjectSPSlice;
